import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="max-w-md text-center space-y-4">
        <div className="text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground">404</div>
        <h1 className="text-3xl font-bold text-foreground">Page not found</h1>
        <p className="text-sm text-muted-foreground">
          The page you are looking for does not exist or may have moved.
        </p>
        <Button onClick={() => navigate("/dashboard")}>Back to Home</Button>
      </div>
    </div>
  );
}

